export default __webpack_public_path__ + "static/media/components-svgrepo-com.f9f81152.svg";